import AppRouter from 'routes/AppRouter';
import AppProviders from 'state/providers/AppProviders';
import AppLoadListeners from './AppLoadListeners';

const AuthenticatedApp: React.FunctionComponent<React.PropsWithChildren> = () => (
  <AppProviders>
    <AppLoadListeners>
      <AppRouter />
    </AppLoadListeners>
  </AppProviders>
);

export default AuthenticatedApp;
